import { useEffect } from "react";
import { datadogRum } from '@datadog/browser-rum';


export const useSessionRecording = () => {
  useEffect(() => {
    datadogRum.init({
      applicationId: 'c12f3baf-4975-4ab0-b801-2d539448c45c',
      clientToken: 'pub34885ebd242757aa76cc453d63ca0336',
      site: 'datadoghq.com',
      service: 'allie-app',
      env: 'test',
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
  }, []);
}
